import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { useGetCurrentBusinessId } from '@/modules/common/hooks/useGetCurrentBusinessId.ts';
import { CURRENT_USER_TASKS_LIST_QUERY_KEY } from '@/modules/common/queries/tasks.ts';
import { GetTaskListResponse, GetTaskListV1TasksGetParams } from 'compliance-api';

export const useTasksListQuery = (payload: GetTaskListV1TasksGetParams, disabled = false) => {
  const { page, ...data } = payload;
  const businessId = useGetCurrentBusinessId();

  return useInfiniteQuery<GetTaskListResponse>({
    queryKey: [CURRENT_USER_TASKS_LIST_QUERY_KEY, JSON.stringify(data), businessId],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    refetchInterval: 1000 * 60 * 5, //5min
    queryFn: async ({ pageParam = 0 }) => {
      const response = await api.v1.getTaskListV1TasksGet({
        ...payload,
        page: pageParam || page,
      });
      return response.data;
    },
    keepPreviousData: true,
    retry: 2,
    getNextPageParam: ({ total, page, page_size }) => {
      const totalPage = Math.ceil(total / page_size);
      const hasMore = totalPage > page;
      if (hasMore) {
        return page + 1;
      }
    },
    enabled: !disabled,
  });
};
